import { Group, Box3 } from "three"
import { FigurativeMark } from './logo/figMark'
import { TextMark } from './logo/textMark'

import { Utils } from "/src/scripts/utils"

export { Logo }

class Logo extends Group {
    #visibility = { appear: true }
    #figMark = new FigurativeMark()
    #textMark = new TextMark()
    #clock
    #ease = Utils.easeInOut(1.5, 4)


    #center() {
        new Box3().setFromObject(this)
            .getCenter(this.position)
            .multiplyScalar(-1)
    }

    async #create() {
        await this.#textMark.load()
        this.#textMark.translateX(2)

        this.add(this.#figMark, this.#textMark)
        this.#center()
    }

    #disappear() {
        if (!this.#visibility.appear) return
        else this.#visibility.cooldown?.()

        this.#visibility = {
            appear: false,
            cooldown: this.#clock.cooldown(
                (cooldown, initialCooldown) => {
                    const deltaEase = this.#ease(cooldown / initialCooldown) - this.#ease(cooldown / initialCooldown - 1 / initialCooldown)
                    this.#textMark.opacity -= deltaEase
                    this.#figMark.opacity -= deltaEase
                    this.translateY(deltaEase)
                    this.translateZ(-1 * deltaEase)
                },
                window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 1 : 20
            )

        }
    }

    #appear() {
        if (this.#visibility.appear) return
        else this.#visibility.cooldown?.()

        this.#visibility = {
            appear: true,
            cooldown: this.#clock.cooldown(
                (cooldown, initialCooldown) => {
                    const deltaEase = this.#ease(cooldown / initialCooldown) - this.#ease(cooldown / initialCooldown - 1 / initialCooldown)
                    this.#textMark.opacity += deltaEase
                    this.#figMark.opacity += deltaEase
                    this.translateY(-1 * deltaEase)
                    this.translateZ(deltaEase)
                },
                window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 1 : 15
            )
        }
    }

    #initScrollListener() {
        const listener = () => {
            const shouldDisappear = window.scrollY > document.documentElement.clientHeight / 5
            if (shouldDisappear) this.#disappear()
            else this.#appear()
        }

        // run this once initially to start in the correct state
        listener()

        window.addEventListener("scroll", listener, { passive: true })
    }

    constructor(clock) {
        super()
        this.#clock = clock

        this.#create()
        this.#initScrollListener()

        this.scale.set(.5, .5, .5)

        // Position the logo slightly above the center of the screen.
        this.translateY(-0.5)
    }
}